import api from "./index";

export async function createAppointment(body) {
  return api.post(`/appointments`, body);
}

export async function getAppointments(params) {
  return api.get(`/appointments`, { params });
}

export async function getAppointment(appointmentID) {
  return api.get(`/appointments/${appointmentID}`);
}

export async function updateAppointment(appointmentID, body) {
  return api.put(`/appointments/${appointmentID}`, body);
}

export async function cancelAppointment(appointmentID) {
  return api.patch(`/appointments/${appointmentID}/cancel`);
}

export async function checkinAppointment(appointmentID) {
  return api.patch(`/appointments/${appointmentID}/checkin`);
}

export async function checkoutAppointment(appointmentID) {
  return api.patch(`/appointments/${appointmentID}/checkout`);
}
export async function markAppointmentReady(appointmentID) {
  return api.patch(`/appointments/${appointmentID}/mark-ready`);
}
export async function markAppointmentIsNotReady(appointmentID) {
  return api.patch(`/appointments/${appointmentID}/mark-not-ready`);
}

export async function getAppointmentEvents(appointmentID) {
  return api.get(`/appointments/${appointmentID}/events`);
}

export async function ratingAppointment(appointmentID, body) {
  return api.patch(`/appointments/${appointmentID}/rating`, body);
}
